import React from 'react';
import { defineMessages, t } from '@sm/intl';

import CovidEndpageHero from '~app/components/CovidEndpageHero';
import EndpageHeader from '~app/components/EndpageHeader';
import FortuneCallout from '~app/components/FortuneCallout';

const COPY = defineMessages({
  ENDPAGE_HEADER_COPY: {
    id: 'SurveyThanks.CovidEndpage.EndpageHeaderCopy',
    defaultMessage: 'Thank you for taking this survey.',
    description: '[Type: Header][Vis: med] - Informs the viewer that this survey has just completed',
  },
  FORTUNE_CALLOUT_COPY: {
    id: 'SurveyThanks.CovidEndpage.FortuneCalloutCopy',
    defaultMessage: '98% of the Fortune 500 rely on SurveyMonkey for People Powered Data',
    description: '[Type: Header][Vis: low] - A promotional statistic designed to show corporate trust and prestige',
  },
  FORTUNE_CALLOUT_CTA: {
    id: 'SurveyThanks.CovidEndpage.FortuneCalloutCTA',
    defaultMessage: 'CREATE A SURVEY',
    description: "[Type: Button][Vis: high] - Fortune's CTA which sends people to a sign up page",
  },
});

const CovidEndpage = () => {
  const utSource = 'survey_thanks';
  const utSource2 = 'covid_endpage';

  return (
    <>
      <EndpageHeader copy={t(COPY.ENDPAGE_HEADER_COPY)} hasLogo headerColor="sabaeus" headerType="thanks" />
      <CovidEndpageHero utSource={utSource} utSource2={utSource2} />
      <FortuneCallout
        copy={t(COPY.FORTUNE_CALLOUT_COPY)}
        ctaText={t(COPY.FORTUNE_CALLOUT_CTA)}
        utSource={utSource}
        utSource2={utSource2}
      />
    </>
  );
};

export default CovidEndpage;
